// PdfModal.tsx
import { Modal, Tabs } from 'antd';
import React from 'react';

interface PdfModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: any;
}

export const PdfModal2: React.FC<PdfModalProps> = ({ open, onClose, data, onConfirm }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={''}
      // footer={<div style={{textAlign: 'center'}}>
      //   <Button type={"primary"} onClick={onConfirm} style={{
      //     position: 'fixed',
      //     zIndex: 100,
      //     bottom: 15,
      //     left: '50%',
      //     marginLeft: '-100px'
      //   }}>Я принимаю соглашение</Button>
      // </div>}
      width="80%"
      style={{ top: 20 }}
    >
      <div style={{ overflow: 'auto', height: '95svh', overflowY: 'auto' }}>
        <Tabs
          defaultActiveKey="kz"
          items={[
            { key: 'kz', label: 'KZ', children: <KZ_PDF /> },
            { key: 'ru', label: 'RU', children: <RU_PDF /> },
          ]}
        />
      </div>
    </Modal>
  );
};

const RU_PDF = () => (
  <>
    <h2 style={{ textAlign: 'center' }}>Пользовательское Соглашение</h2>
    <p style={{ textAlign: 'center' }}>
      это Договор о правах и взаимных обязательствах
      <br />
      двух сторон «Пользователь-Представитель»,
      <br />
      возникающих при покупке Импульсного Модуля FPDtech «Super Torque».
    </p>
    <p>Статья 1.</p>
    <p>
      Пользователь имеет право:1.1. получать чек при оплате Импульсного Модуля FPDtech «Super
      Torque»;
    </p>
    <p>
      1.2. получать Импульсный Модуль FPDtech «Super Torque» в исправном состоянии, а именно, лично
      присутствовать при проверке исправности Импульсного Модуля FPDtech «Super Torque»;
    </p>
    <p>примечание:</p>
    <p>
      проверка осуществляется после оплаты и распаковки (в случае наличия упаковки), до подключения
      и активации Гарантийных обязательств Производителя;
    </p>
    <p>
      1.3. получать полный пакет сервисных услуг в FPDtech-Сервис-Центре Представителя по всем
      пунктам Регистрационной Формы FPDtech согласно требованиям Технического Регламента FPDtech;
    </p>
    <p>
      1.4. получать в полном объеме разъяснения от специалистов FPDtech-Сервис-Центра при проведении
      работ, необходимых для полного заполнения всех пунктов Регистрационной Формы FPDtech;
    </p>
    <p>
      1.5. получать в полном объеме информацию о программах «Льготная цена», «Агентское соглашение»;
    </p>
    <p>
      1.6. получать извещения/уведомления о мероприятиях и акциях, проводимых Представителем
      FPDtech, новых услугах или изменениях условий программ;
    </p>
    <p>
      1.7. на возврат Импульсного Модуля FPDtech «Super Torque» в течение действия срока возврата,
      который определяется действующим локальным законодательством (в РК 14 дней);
    </p>
    <p>примечание:</p>
    <p>
      при возврате Импульсного Модуля FPDtech «Super Torque» возврат Пользователю денежных средств,
      фактически потраченных Пользователем на оплату Импульсного Модуля FPDtech «Super Torque» в
      полном объеме возможен и осуществляется только после полной проверки исправности и оценки
      соответствия критериям «Исправность Импульсного Модуля FPDtech «Super Torque» и «Соответствие
      товарного вида Импульсного Модуля FPDtech «Super Torque» и полного заполнения Формы возврата,
      при условии исправности и соответствия критериям «Исправность Импульсного Модуля FPDtech
      «Super Torque» и «Соответствие товарного вида Импульсного Модуля FPDtech «Super Torque», к
      которым устраняемое загрязнение корпуса и коммутации не относятся;
    </p>
    <p>примечание:</p>
    <p>
      очевидная невозможность повторной продажи со скидкой следующему Пользователю возвращаемого
      Импульсного Модуля FPDtech «Super Torque» является неоспоримым основанием для Представителя
      для невозврата суммы фактической оплаты, произведенной Пользователем при покупке Импульсного
      Модуля FPDtech «Super Torque»;
    </p>
    <p>
      1.8. в случае неработоспособности Импульсного Модуля FPDtech «Super Torque» в течение срока
      исполнения Гарантийных обязательств Производителя на бесплатную замену и бесплатную
      установку/подключение нового Импульсного Модуля FPDtech «Super Torque» в течение всего срока
      действия Гарантийных обязательств Производителя; в этом случае неработоспособность Импульсного
      Модуля FPDtech «Super Torque» отменяет необходимость соответствия критериям «Исправность
      Импульсного Модуля FPDtech «Super Torque» и «Соответствие товарного вида Импульсного Модуля
      FPDtech «Super Torque»;
    </p>
    <p>примечание 1:</p>
    <p>
      срок выполнения Гарантийных обязательств Производителя может быть изменен в сторону увеличения
      срока в случаях, когда предусмотрены дополнительные бонусные условия, согласие на которые
      является добровольным, на усмотрение Пользователя;
    </p>
    <p>примечание 2:</p>
    <p>
      при замене Импульсного Модуля FPDtech «Super Torque» по гарантии срок исполнения Гарантийных
      обязательств Производителя начинается заново со дня замены;
    </p>
    <p>
      срок исполнения Гарантийных обязательств Производителя в этом случае не может быть меньше, чем
      первоначально заявленный;
    </p>
    <p>
      серийный номер нового Импульсного Модуля FPDtech «Super Torque» должен быть отправлен
      посредством прямой коммуникации Пользователя с Производителем на сайте Производителя
      www.fpdtech.kz для подтверждения и активации нового срока действия Гарантийных обязательств
      Производителя;
    </p>
    <p>примечание 3:</p>
    <p>
      бонусные условия включают в себя, в том числе, возможность для Пользователя оплаты продления
      срока исполнения Гарантийных обязательств Производителя через прямую коммуникацию с
      Производителем на сайте Производителя www.fpdtech.kz;
    </p>
    <p>
      стоимость услуги продления срока Гарантийных обязательств Производителя составляет, на один
      год, 10% от суммы официальной полной стоимости Импульсного Модуля FPDtech «Super Torque», без
      учета скидок по программе «Льготная цена»;
    </p>
    <p>примечание 4:</p>
    <p>
      срок выполнения Гарантийных обязательств Производителя может быть изменен Производителем без
      участия Представителя в сторону уменьшения срока в случаях невыполнения условий активации
      Гарантийных обязательств Производителя.
    </p>
    <p>примечание 5:</p>
    <p>
      Гарантийные обязательства Производителя относятся исключительно к исправности Импульсного
      Модуля FPDtech «Super Torque». Стандартный срок Гарантийных обязательств Производителя
      составляет 12 (двенадцать) месяцев с момента активации Гарантийных обязательств Производителя;
    </p>
    <p>
      1.9. получать в обязательном порядке бумажный экземпляр полностью заполненной Регистрационной
      Формы FPDtech и бумажный экземпляр Пользовательского Соглашения, заверенный подписями обоих
      Сторон;
    </p>
    <p>
      1.10. получать от Представителя одним платежом 18% от уплаченной суммы на покупку Импульсного
      Модуля FPDtech «Super Torque» при выполнении условий программы «Льготная цена» сразу после
      полного заполнении Регистрационной Формы.
    </p>
    <p>Статья 2.</p>
    <p>Официальный Представитель FPDtech (далее - Представитель) обязуется:</p>
    <p>2.1. выдавать чек, подтверждающий оплату Импульсного Модуля FPDtech «Super Torque»;</p>
    <p>
      2.2. после оплаты проверять исправность и соответствие товарного вида Импульсного Модуля
      FPDtech «Super Torque» в присутствии Пользователя;выдавать Пользователю Импульсный Модуль
      FPDtech «Super Torque», соответствующий критериям «Исправность Импульсного Модуля FPDtech
      «Super Torque» и «Соответствие товарного вида Импульсного Модуля FPDtech «Super Torque»;
    </p>
    <p>
      2.3. обеспечить в полном объеме выполнение сервисных услуг в FPDtech-Сервис-Центре
      Представителя по всем пунктам Регистрационной Формы FPDtech согласно требований Технического
      Регламента FPDtech;
    </p>
    <p>
      2.4. в полном объеме давать разъяснения при проведении работ, необходимых для полного
      заполнения всех пунктов Регистрационной Формы FPDtech, в том числе, оказывать, в случае
      необходимости, содействие Пользователю при прямой коммуникации Пользователя с Производителем
      на сайте Производителя www.fpdtech.kz;
    </p>
    <p>
      2.5. в полном объеме давать разъяснения о программах «Льготная цена», «Агентское соглашение»;
    </p>
    <p>
      2.6. отправлять извещения/уведомления о мероприятиях и акциях, проводимых Представителем
      FPDtech, новых услугах или изменениях условий программ если Пользователь подтвердил и дал
      Согласие Пользователя в письменной или электронной форме на услугу по получению
      извещений/уведомлений от Представителя FPDtech;
    </p>
    <p>
      2.7. обеспечить выполнение безусловного права Пользователя на возврат Импульсного Модуля
      FPDtech «Super Torque» в течение действия срока возврата, который определяется действующим
      локальным законодательством (в РК 14 дней);
    </p>
    <p>примечание:</p>
    <p>
      при возврате Импульсного Модуля FPDtech «Super Torque» возврат Пользователю денежных средств,
      фактически потраченных Пользователем на оплату Импульсного Модуля FPDtech «Super Torque» в
      полном объеме возможен и осуществляется только после полной проверки исправности и оценки
      соответствия критериям «Исправность Импульсного Модуля FPDtech «Super Torque» и «Соответствие
      товарного вида Импульсного Модуля FPDtech «Super Torque» и полного заполнения Формы возврата,
      при условии исправности и соответствия критериям «Исправность Импульсного Модуля FPDtech
      «Super Torque» и «Соответствие товарного вида Импульсного Модуля FPDtech «Super Torque», к
      которым устраняемое загрязнение корпуса и коммутации не относятся;
    </p>
    <p>
      2.8. обеспечить выполнение безусловного права Пользователя в случае неработоспособности
      Импульсного Модуля FPDtech «Super Torque» в течение срока исполнения Гарантийных обязательств
      Производителя на бесплатную замену и бесплатную установку/подключение нового Импульсного
      Модуля FPDtech «Super Torque» в течение всего срока действия Гарантийных обязательств
      Производителя; в этом случае неработоспособность Импульсного Модуля FPDtech «Super Torque»
      отменяет необходимость соответствия критериям «Исправность и соответствие товарного вида
      Импульсного Модуля FPDtech «Super Torque»;
    </p>
    <p>примечание 1:</p>
    <p>
      при замене Импульсного Модуля FPDtech «Super Torque» по гарантии срок исполнения Гарантийных
      обязательств Производителя начинается заново со дня замены;
    </p>
    <p>
      срок исполнения Гарантийных обязательств Производителя в этом случае не может быть меньше, чем
      первоначально заявленный;
    </p>
    <p>
      серийный номер нового Импульсного Модуля FPDtech «Super Torque» должен быть отправлен
      посредством прямой коммуникации Пользователя с Производителем на сайте Производителя
      www.fpdtech.kz для подтверждения и активации нового срока действия Гарантийных обязательств
      Производителя;
    </p>
    <p>примечание 2:</p>
    <p>
      срок выполнения Гарантийных обязательств Производителя может быть изменен в сторону увеличения
      срока в случаях, когда предусмотрены дополнительные бонусные условия, согласие на которые
      является добровольным, на усмотрение Пользователя;
    </p>
    <p>примечание 3:</p>
    <p>
      бонусные условия включают в себя, в том числе, возможность для Пользователя оплаты продления
      срока исполнения Гарантийных обязательств Производителя через прямую коммуникацию с
      Производителем на сайте Производителя www.fpdtech.kz;
    </p>
    <p>
      стоимость услуги продления срока Гарантийных обязательств Производителя составляет, на один
      год, 10% от суммы официальной полной стоимости Импульсного Модуля FPDtech «Super Torque», без
      учета скидок по программе «Льготная цена»;
    </p>
    <p>примечание 4:</p>
    <p>
      срок выполнения Гарантийных обязательств Производителя без участия Представителя может быть
      изменен Производителем в сторону уменьшения срока в случаях невыполнения условий активации
      Гарантийных обязательств Производителя;
    </p>
    <p>примечание 5:</p>
    <p>
      Гарантийные обязательства Производителя относятся исключительно к исправности Импульсного
      Модуля FPDtech «Super Torque». Стандартный срок Гарантийных обязательств Производителя
      составляет 12 (двенадцать) месяцев с момента активации Гарантийных обязательств Производителя.
    </p>
    <p>
      2.9. в случае смены ТС Пользователя во время действия Гарантийных обязательств Производителя
      осуществлять переустановку Импульсного Модуля FPDtech «Super Torque» на другое ТС Пользователя
      по льготной цене, установленной по усмотрению Представителя, но не превышающей 10% от суммы
      официальной полной стоимости Импульсного Модуля FPDtech «Super Torque», без учета скидок по
      программе «Льготная цена»;
    </p>
    <p>
      2.10. в случае смены ТС Пользователя после окончания срока действия Гарантийных обязательств
      Производителя осуществлять переустановку Импульсного Модуля FPDtech «Super Torque» на другое
      ТС Пользователя по льготной цене, установленной по усмотрению Представителя, но не превышающей
      20% от суммы официальной полной стоимости Импульсного Модуля FPDtech «Super Torque», без учета
      скидок по программе «Льготная цена»;
    </p>
    <p>
      2.11. не передавать третьим лицам и/или публично разглашать, устно или письменно, личную
      информацию Пользователя, а именно Фамилию, Имя, контактный номер телефона Пользователя, номер
      государственной регистрации ТС Пользователя, на которое установлен Импульсный Модуль FPDtech
      «Super Torque»;
    </p>
    <p>
      2.12. выдавать в обязательном порядке бумажный экземпляр полностью заполненной Регистрационной
      Формы FPDtech и бумажный экземпляр Пользовательского Соглашения, заверенный подписями обоих
      Сторон.
    </p>
    <p>
      2.13. выдавать Пользователю одним платежом 18% от уплаченной суммы на покупку Импульсного
      Модуля FPDtech «Super Torque» при выполнении условий программы «Льготная цена» сразу после
      полного заполнении Регистрационной Формы.
    </p>
    <p>Статья 3.</p>
    <p>Пользователь обязуется:</p>
    <p>3.1. не использовать Импульсный Модуль FPDtech «Super Torque» не по назначению;</p>
    <p>примечание:</p>
    <p>
      назначение моделей Импульсного Модуля FPDtech «Super Torque» по классу ТС и напряжению
      электросети ТС данного класса публикуются на сайте Производителя www.fpdtech.kz;
    </p>
    <p>примечание:</p>
    <p>
      к использованию не по назначению относится, в том числе, самостоятельная, то есть без участия
      специалиста FPDtech-Сервис-Центра, установка/подключение Импульсного Модуля FPDtech «Super
      Torque» и установка/подключение модели Импульсного Модуля FPDtech «Super Torque» с указанными
      классом ТС и параметрами напряжения электросети ТС данного класса на ТС другого класса и
      другими параметрами напряжения электросети ТС;
    </p>
    <p>
      3.2 не передавать третьим лицам Импульсный Модуль FPDtech «Super Torque» для использования не
      по назначению;
    </p>
    <p>
      3.3. предоставлять достоверные данные при заполнении всех пунктов Регистрационной Формы
      FPDtech;
    </p>
    <p>примечание:</p>
    <p>
      в случае изменения данных Пользователя, а именно Фамилии, Имени, номера контактного телефона
      Пользователя, смены ТС, своевременно, то есть, не позднее окончания срока Гарантийных
      обязательств Производителя уведомлять об изменениях через прямую коммуникацию с Производителем
      на сайте Производителя www.fpdtech.kz;
    </p>
    <p>примечание:</p>
    <p>
      выявление и/или подтверждение факта предоставления недостоверных данных, неумышленного или
      преднамеренного характера, освобождает Производителя от выполнения Гарантийных обязательств
      Производителя и, одновременно, освобождает Представителя от выполнения солидарных Гарантийных
      обязательств Представителя;
    </p>
    <p>
      3.4. предоставить Производителю безоговорочное, по умолчанию, право на публикацию данных,
      полученных при заполнении Регистрационной Формы FPDtech согласно требований Технического
      Регламента FPDtech в случаях, когда публикация не содержит информацию персонального характера,
      а именно Фамилию, Имя, контактный номер телефона Пользователя, номер государственной
      регистрации ТС Пользователя, на которое установлен Импульсный Модуль FPDtech «Super Torque»;
    </p>
    <p>
      3.5. при смене ТС, на которое установлен Импульсный Модуль FPDtech «Super Torque» осуществлять
      переустановку Импульсного Модуля FPDtech «Super Torque» на другое ТС в FPDtech-Сервис-Центре
      Представителя для активации Гарантийных обязательств Производителя;
    </p>
    <p>примечание:</p>
    <p>
      переустановка на другое ТС в FPDtech-Сервис-Центре Представителя осуществляется по льготной
      цене, обусловленной пунктами 2.9. и 2.10. Статьи 2 данного Соглашения;
    </p>
    <p>3.6. ознакомиться со всеми пунктами Пользовательского Соглашения;</p>
    <p>
      3.7. подтвердить свое согласие с условиями всех пунктов всей статей данного Пользовательского
      Соглашения личной подписью Пользователя с расшифровкой, то есть собственноручно написать
      Фамилию и Имя;
    </p>
    <p>
      3.8. считать, в случаях невозможности поставить личную подпись с расшифровкой, факт оплаты
      Импульсного Модуля FPDtech «Super Torque» подтверждением, равным личной подписи Пользователя в
      письменном виде, выполнения пунктов 3.6. и 3.7. данного Пользовательского Соглашения и
      согласием Пользователя на выполнение условий всех пунктов всех статей данного
      Пользовательского Соглашения в полном объеме;
    </p>
    <p>
      3.9. нести полную личную материальную ответственность за исправное эксплуатационное состояние
      собственного ТС, в том числе, за соответствие всех комплектующих, узлов и агрегатов
      собственного ТС техническим условиям и требованиям Производителя ТС и отсутствие
      несертифицированных устройств нестандартной комплектации до установки Импульсного Модуля
      FPDtech «Super Torque» на ТС Пользователя.
    </p>
    <p>Статья 4.</p>
    <p>Представитель имеет право:</p>
    <p>
      4.1. следуя условиям Соглашения о Партнерстве с Официальным Производителем FPDtech, отказать
      Пользователю в продаже Импульсного Модуля FPDtech «Super Torque» в случаях, когда ТС
      Пользователя не соответствует критериям исправного ТС согласно требованиям Технического
      Регламента FPDtech;
    </p>
    <p>
      4.2. перенести срок проведения работ в случаях, когда оборудование, необходимое для выполнения
      работ по всем пунктам Регистрационной Формы FPDtech согласно требований Технического
      Регламента FPDtech находится на ремонтно-профилактическом обслуживании;
    </p>
    <p>
      4.3. при возврате в течение срока возврата (в РК 14 дней) исправного Импульсного Модуля
      FPDtech «Super Torque», не в полной мере соответствующего критериям «Исправность Импульсного
      Модуля FPDtech «Super Torque» и «Соответствие товарного вида Импульсного Модуля FPDtech «Super
      Torque», самостоятельно определять сумму возврата, руководствуясь возможностью или
      невозможностью повторной продажи со скидкой следующему Пользователю;
    </p>
    <p>примечание:</p>
    <p>
      очевидная невозможность повторной продажи со скидкой следующему Пользователю является
      неоспоримым основанием для невозврата суммы фактической оплаты, произведенной Пользователем на
      покупку Импульсного Модуля FPDtech «Super Torque»;
    </p>
    <p>
      4.4. на разработку и внедрение собственных льготных пользовательских программ и акций в целях
      привлечения новых Пользователей при условии непротиворечия этих программ и акций всем пунктам
      всех статей данного Пользовательского Соглашения и Соглашения о Партнерстве с Официальным
      Производителем FPDtech;
    </p>
    <p>
      4.5. предлагать собственные услуги и товары, не относящиеся к выполнению условий Соглашения о
      Партнерстве с Официальным Производителем FPDtech;
    </p>
    <p>Статья 5.</p>
    <p>Проверка исправности</p>
    <p>
      Импульсного Модуля FPDtech «Super Torque» проверка исправности Импульсного Модуля FPDtech
      «Super Torque» проводится в следующей последовательности:
    </p>
    <p>5.1. включить зажигание ТС - светодиодный индикатор на крышке Модуля загорается;</p>
    <p>5.2. выключить зажигание, светодиодный индикатор на крышке Модуля гаснет;</p>
    <p>5.3. извлечь Предохранитель из корпуса;</p>
    <p>5.4. на Мультиметре установить режим «миллиамперы постоянного тока»;</p>
    <p>5.5. щупы Мультиметра соединить с контактными гнездами в корпусе Предохранителя;</p>
    <p>5.6. включить зажигание ТС - светодиодный индикатор на крышке Модуля загорается;</p>
    <p>
      5.7. ток потребления на дисплее Мультиметра «10-100мА» или «-10-100мА» означает, что Модуль
      ИСПРАВЕН;
    </p>
    <p>5.8. выключить зажигание;</p>
    <p>5.9. подключить Предохранитель, проверка закончена.</p>
    <p>
      В случаях, когда при включенном зажигании светодиодный ИНДИКАТОР на крышке Модуля НЕ
      ЗАГОРАЕТСЯ, проверка исправности Импульсного Модуля FPDtech «Super Torque» проводится в
      следующей последовательности:
    </p>
    <p>5.10. выключить зажигание;</p>
    <p>
      5.11. отщелкнуть Модуль от коммутации и отсоединить коммутацию от сети электропитания
      автомобиля;
    </p>
    <p>
      5.12. извлечь Предохранитель из корпуса для проведения приборной проверки исправности
      Предохранителя; если Предохранитель исправен, то, далее
    </p>
    <p>5.13. на Мультиметре установить режим «прозвон диодов»;</p>
    <p>5.14. защелкнуть коммутацию на корпусе Модуля;</p>
    <p>
      5.15. красный провод/«+» коммутации соединить с щупом «-» Мультиметра, черный провод/«-»
      коммутации соединить с щупом «+» Мультиметра;
    </p>
    <p>
      5.16. в случае, когда дисплей Мультиметра показывает «0,5-0,8V» Модуль ИСПРАВЕН, но относится
      к категории «брак Производителя» и подлежит замене по Гарантии Производителя, проверка
      закончена. В отдельных случаях, когда при включенном зажигании светодиодный ИНДИКАТОР на
      крышке Модуля НЕ ЗАГОРАЕТСЯ и приборная проверка исправности Предохранителя выявила
      неисправность Предохранителя,
    </p>
    <p>рекомендуется:</p>
    <p>
      заменить Предохранитель на исправный и подключить его к контактным гнездам в корпусе
      Предохранителя;
    </p>
    <p>
      если, при включенном зажигании светодиодный ИНДИКАТОР на крышке Модуля ЗАГОРАЕТСЯ, то Модуль
      ИСПРАВЕН, проверка закончена.
    </p>
    <p>
      Если, после замены неисправного Предохранителя, при включенном зажигании светодиодный
      индикатор на крышке Модуля НЕ ЗАГОРАЕТСЯ, проверка исправности Модуля продолжается в следующем
      порядке:
    </p>
    <p>5.17. на Мультиметре установить режим «прозвон диодов»;</p>
    <p>
      5.18. отщелкнуть Модуль от коммутации и отсоединить коммутацию от сети электропитания
      автомобиля;
    </p>
    <p>5.19. защелкнуть коммутацию на корпусе Модуля;</p>
    <p>
      5.20. красный провод/«+» коммутации соединить с щупом «-» Мультиметра, черный провод/«-»
      коммутации соединить с щупом «+» Мультиметра;
    </p>
    <p>
      5.21. в случае, когда дисплей Мультиметра показывает «0,5-0,8V», Модуль ИСПРАВЕН, но относится
      к категории «брак Производителя» и подлежит замене по Гарантии Производителя, проверка
      закончена;
    </p>
    <p>
      5.22. в случае, когда дисплей Мультиметра показывает «0» или «1» или другое обозначение
      «бесконечного падения напряжения», это означает, что Модуль ВЫВЕДЕН ИЗ СТРОЯ по причине
      НЕСОБЛЮДЕНИЯ полярности или попытке установки Модуля на ТС другой категории, приведшее к
      НЕОБРАТИМОЙ НЕИСПРАВНОСТИ Модуля.
    </p>
    <p>Уведомление Производителя:</p>
    такой случай, а именно, приборно установленное подтверждение неправильного подключения
    коммутации Модуля по причине несоблюдения полярности, приведшее к необратимой неисправности
    Модуля, не может быть отнесен к категории «брак Производителя», является невыполнением,
    неумышленного или преднамеренного характера, пункта 3.1. и основанием для Представителя
    невозврата денежных средств Пользователя, фактически потраченных на покупку Импульсного Модуля
    FPDtech «Super Torque» вследствие невыполнения обязательств Пользователя.
    <p>Статья 6.</p>
    <p>Критерии «Соответствие товарного вида Импульсного Модуля FPDtech «Super Torque»:</p>
    <p>
      6.1. отсутствие видимых следов повреждения корпуса, а именно - сколов, вмятин, царапин, следов
      термического, термоэлектрического воздействия, трудноудаляемых и/или неудаляемых следов
      технических жидкостей, следов химического и электрохимического воздействия, отсутствие видимых
      механических повреждений коммутационного блока на крышке корпуса;
    </p>
    <p>
      6.2. к повреждениям коммутации относятся нарушение изоляции проводов коммутации, механические
      переломы, следы термического, термоэлектрического воздействия, трудноудаляемые и/или
      неудаляемые следы технических жидкостей, следы химического и электрохимического воздействия,
      механическое повреждение блока внешнего предохранителя;
    </p>
    <p>
      6.3. поврежденная коммутация ремонту и возврату не подлежит; сумма удержания за поврежденную
      коммутацию озвучивается Представителем при продаже и не превышает 10% от суммы официальной
      полной стоимости Импульсного Модуля FPDtech «Super Torque», без учета скидок по программе
      «Льготная цена»;
    </p>
    <p>Статья 7.</p>
    <p>Разрешение споров между сторонами «Пользователь» «Представитель».</p>
    <p>
      7.1. приоритетным решением спора признается урегулирование разногласий между Сторонами в
      досудебном порядке;
    </p>
    <p>
      7.2. возможные претензии со стороны Пользователя в случаях выявления неисправностей ТС
      Пользователя, проявившихся после подключения Импульсного Модуля FPDtech «Super Torque», а
      также в случаях, когда, по мнению Пользователя, эффективность работы Импульсного Модуля
      FPDtech «Super Torque» не была подтверждена на практике на ТС Пользователя, принимаются к
      рассмотрению Представителем только в соответствии Протоколу Рассмотрения Претензий;
    </p>
    <p>примечание:</p>
    <p>
      Протокол Рассмотрения Претензий включает в себя перечень необходимых документов со стороны
      Пользователя, а именно: оригинал Пользовательского Соглашения, оригинал чека, оригинал
      Регистрационной Формы, Экспертное Заключение сертифицированного учреждения о текущем
      эксплуатационном состоянии всех систем ТС Пользователя и соответствию всех систем ТС
      Пользователя требованиям Технического регламента Производителя ТС Пользователя до даты
      установки Импульсного Модуля FPDtech «Super Torque» на ТС Пользователя;
    </p>
    <p>примечание:</p>
    <p>
      Экспертное Заключение сертифицированного учреждения о текущем эксплуатационном состоянии всех
      систем ТС Пользователя и соответствию всех систем ТС Пользователя требованиям Технического
      регламента Производителя ТС Пользователя до даты установки Импульсного Модуля FPDtech «Super
      Torque» на ТС Пользователя может быть единственным основанием для сравнения и выявления
      разницы в работе систем ТС Пользователя до и после установки Модуля путем проведения
      комплексных сравнительных тестов при участии независимых экспертов.
    </p>
    <p>Статья 8.</p>
    <p>Срок действия Договора.</p>
    <p>8.1. Срок действия данного Пользовательского Соглашения 12 (двенадцать) месяцев.</p>
    <p>
      8.2. К сроку действия данного Пользовательского Соглашения не относится возможное продление
      срока исполнения Гарантийных обязательств Производителя через прямую коммуникацию Пользователя
      с Производителем на сайте Производителя www.fpdtech.kz согласно примечанию 3. Статьи 1.
      данного Пользовательского Соглашения.
    </p>
    <p>
      8.3. Данное Пользовательское Соглашение вступает в силу с момента подписания обеими Сторонами.
    </p>
  </>
);

const KZ_PDF = () => (
  <>
    <style>{`ol{margin:0;padding:0}table td,table th{padding:0}.c16{-webkit-text-decoration-skip:none;color:#000080;font-weight:400;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:9pt;font-family:"Times New Roman";font-style:normal}.c43{-webkit-text-decoration-skip:none;color:#000080;font-weight:400;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:12pt;font-family:"Times New Roman";font-style:normal}.c53{margin-left:54.3pt;padding-top:6.3pt;text-indent:-18.1pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:20.4pt}.c35{margin-left:0.2pt;padding-top:5.9pt;text-indent:0pt;padding-bottom:0pt;line-height:0.957949161529541;text-align:left;margin-right:1.3pt}.c38{margin-left:54.1pt;padding-top:6.1pt;text-indent:-17pt;padding-bottom:0pt;line-height:0.9625743627548218;text-align:left;margin-right:53.3pt}.c70{margin-left:54.2pt;padding-top:6.1pt;text-indent:-17.8pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:59.7pt}.c96{margin-left:54.1pt;padding-top:6.2pt;text-indent:-17.9pt;padding-bottom:0pt;line-height:0.9625779390335083;text-align:left;margin-right:7.9pt}.c52{margin-left:54.2pt;padding-top:6.1pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9594928026199341;text-align:left;margin-right:0.5pt}.c31{margin-left:54.4pt;padding-top:6.3pt;text-indent:-18.2pt;padding-bottom:0pt;line-height:0.9533225297927856;text-align:left;margin-right:29.3pt}.c42{margin-left:54.3pt;padding-top:6.3pt;text-indent:-17.3pt;padding-bottom:0pt;line-height:0.957949161529541;text-align:left;margin-right:10pt}.c41{margin-left:0.1pt;padding-top:5.8pt;text-indent:0.1pt;padding-bottom:0pt;line-height:0.957949161529541;text-align:justify;margin-right:20.4pt}.c30{margin-left:0.3pt;padding-top:5.8pt;text-indent:-0pt;padding-bottom:0pt;line-height:0.9625800251960754;text-align:left;margin-right:31.5pt}.c17{margin-left:0.2pt;padding-top:5.8pt;text-indent:-0pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:47.2pt}.c77{margin-left:36.4pt;padding-top:5.9pt;text-indent:-36.2pt;padding-bottom:0pt;line-height:1.5132838487625122;text-align:left;margin-right:37.4pt}.c57{margin-left:54.3pt;padding-top:5.8pt;text-indent:-17.2pt;padding-bottom:0pt;line-height:0.9625800251960754;text-align:left;margin-right:16pt}.c51{margin-left:54.1pt;padding-top:5.9pt;text-indent:-17.8pt;padding-bottom:0pt;line-height:0.9579476714134216;text-align:left;margin-right:8.6pt}.c68{margin-left:54.3pt;padding-top:5.8pt;text-indent:-17.8pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:26.8pt}.c10{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:"Times New Roman";font-style:italic}.c3{margin-left:0.2pt;padding-top:5.9pt;text-indent:0pt;padding-bottom:0pt;line-height:0.9579499959945679;text-align:left;margin-right:1.3pt}.c66{margin-left:0.2pt;padding-top:5.9pt;text-indent:0.1pt;padding-bottom:0pt;line-height:0.9533267021179199;text-align:left;margin-right:22.1pt}.c79{margin-left:54.1pt;padding-top:5.9pt;text-indent:-17.6pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:20pt}.c58{margin-left:54.1pt;padding-top:6.1pt;text-indent:-17.9pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:9.2pt}.c60{margin-left:55.1pt;padding-top:6.1pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9625779390335083;text-align:left;margin-right:1.6pt}.c26{margin-left:54.1pt;padding-top:5.8pt;text-indent:-17.9pt;padding-bottom:0pt;line-height:0.9579505920410156;text-align:left;margin-right:9.1pt}.c94{margin-left:0.2pt;padding-top:6.1pt;text-indent:-0pt;padding-bottom:0pt;line-height:0.9625785946846008;text-align:left;margin-right:17.1pt}.c39{margin-left:55.1pt;padding-top:0pt;text-indent:-18.9pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:1.6pt}.c84{margin-left:54pt;padding-top:22.2pt;text-indent:-16.9pt;padding-bottom:0pt;line-height:0.9625779390335083;text-align:left;margin-right:25.4pt}.c65{margin-left:54.3pt;padding-top:5.8pt;text-indent:-17.3pt;padding-bottom:0pt;line-height:0.9625743627548218;text-align:left;margin-right:8.5pt}.c0{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:"Times New Roman";font-style:normal}.c74{margin-left:0.4pt;padding-top:5.9pt;text-indent:-0.2pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:28.1pt}.c12{margin-left:54.2pt;padding-top:5.9pt;text-indent:-17.6pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:0.2pt}.c2{margin-left:0.3pt;padding-top:5.9pt;text-indent:-0.1pt;padding-bottom:0pt;line-height:0.9533225297927856;text-align:left;margin-right:28.5pt}.c89{margin-left:54.2pt;padding-top:5.8pt;text-indent:-17.8pt;padding-bottom:0pt;line-height:0.9579498767852783;text-align:left;margin-right:0.2pt}.c69{margin-left:0.1pt;padding-top:0.9pt;text-indent:0.1pt;padding-bottom:0pt;line-height:0.9718332886695862;text-align:left;margin-right:2.9pt}.c54{margin-left:0.1pt;padding-top:5.8pt;text-indent:0.3pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:13.7pt}.c46{margin-left:54.1pt;padding-top:6.1pt;text-indent:-17.7pt;padding-bottom:0pt;line-height:0.9579505920410156;text-align:left;margin-right:19.8pt}.c92{margin-left:54.2pt;padding-top:6.3pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:2.9pt}.c29{margin-left:0.1pt;padding-top:5.8pt;text-indent:0.1pt;padding-bottom:0pt;line-height:0.9579498767852783;text-align:left;margin-right:26.8pt}.c82{margin-left:36.5pt;padding-top:22.2pt;text-indent:-36.2pt;padding-bottom:0pt;line-height:1.5179133415222168;text-align:left;margin-right:6.5pt}.c86{margin-left:54.2pt;padding-top:6.1pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9625800251960754;text-align:left;margin-right:12.6pt}.c22{margin-left:0.2pt;padding-top:6.1pt;text-indent:-0pt;padding-bottom:0pt;line-height:0.9625800251960754;text-align:left;margin-right:17.1pt}.c63{margin-left:0.3pt;padding-top:6.1pt;text-indent:-0.1pt;padding-bottom:0pt;line-height:1.5179133415222168;text-align:left;margin-right:124pt}.c47{margin-left:54.1pt;padding-top:5.8pt;text-indent:-17.7pt;padding-bottom:0pt;line-height:0.9579505920410156;text-align:left;margin-right:2.3pt}.c75{margin-left:54.3pt;padding-top:6.3pt;text-indent:-17.9pt;padding-bottom:0pt;line-height:0.9579505920410156;text-align:left;margin-right:21.2pt}.c34{margin-left:54.2pt;padding-top:5.8pt;text-indent:-17.1pt;padding-bottom:0pt;line-height:0.9625800251960754;text-align:left;margin-right:3.9pt}.c88{margin-left:54pt;padding-top:6.1pt;text-indent:-17.8pt;padding-bottom:0pt;line-height:0.9625779390335083;text-align:left;margin-right:21.5pt}.c33{margin-left:0.2pt;padding-top:5.9pt;text-indent:0pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:2.6pt}.c91{margin-left:54.1pt;padding-top:0pt;text-indent:-17.7pt;padding-bottom:0pt;line-height:0.9579476714134216;text-align:left;margin-right:2.5pt}.c44{margin-left:54.1pt;padding-top:6.1pt;text-indent:-17.7pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:left;margin-right:45.3pt}.c7{margin-left:54.2pt;padding-top:22.6pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9579498767852783;text-align:left;margin-right:5.4pt}.c64{margin-left:0.2pt;padding-top:5.9pt;text-indent:0pt;padding-bottom:0pt;line-height:0.9533210396766663;text-align:left;margin-right:20.6pt}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:"Times New Roman";font-style:normal}.c71{margin-left:54.2pt;padding-top:5.8pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9625743627548218;text-align:left;margin-right:7.9pt}.c72{margin-left:54.2pt;padding-top:6.3pt;text-indent:-18pt;padding-bottom:0pt;line-height:0.9579498767852783;text-align:left;margin-right:12pt}.c55{margin-left:54.3pt;padding-top:22.6pt;text-indent:-18.1pt;padding-bottom:0pt;line-height:0.9579505920410156;text-align:left;margin-right:10pt}.c80{padding-top:1.3pt;padding-bottom:0pt;line-height:0.9533210396766663;text-indent:0.2pt;text-align:left;margin-right:17.9pt}.c50{margin-left:0.2pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.5086557865142822;text-align:center;margin-right:5.4pt}.c83{margin-left:36.4pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.5179133415222168;text-align:center;margin-right:81.1pt}.c11{margin-left:36.5pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.5086572170257568;text-align:left;margin-right:62pt}.c78{margin-left:36.4pt;padding-top:6.3pt;padding-bottom:0pt;line-height:0.9533239603042603;text-align:center;margin-right:16.4pt}.c28{margin-left:5.3pt;padding-top:5.8pt;padding-bottom:0pt;line-height:0.9625743627548218;text-align:center;margin-right:4.8pt}.c6{margin-left:0.2pt;padding-top:5.8pt;padding-bottom:0pt;line-height:0.9594918489456177;text-indent:0.1pt;text-align:left}.c25{padding-top:5.9pt;padding-bottom:0pt;line-height:0.9564074277877808;text-indent:0.1pt;text-align:left;margin-right:27.8pt}.c37{margin-left:36.2pt;padding-top:5.8pt;padding-bottom:0pt;line-height:0.962577223777771;text-align:center;margin-right:4.4pt}.c56{margin-left:0.3pt;padding-top:5.7pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c93{margin-left:0.1pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c87{margin-left:37.1pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c20{margin-left:0.2pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c9{margin-left:36.5pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c49{margin-left:36.4pt;padding-top:6.2pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c48{margin-left:36.5pt;padding-top:6.3pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c13{margin-left:0.2pt;padding-top:1.3pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c40{margin-left:0.1pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c19{margin-left:37.1pt;padding-top:6.1pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c76{margin-left:36.4pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c81{margin-left:36.4pt;padding-top:6.1pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c15{margin-left:0.3pt;padding-top:1.1pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c14{margin-left:36.5pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c23{margin-left:36.5pt;padding-top:1.3pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c85{margin-left:36.6pt;padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c32{margin-left:36.6pt;padding-top:6.3pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c62{margin-left:36.2pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c5{margin-left:36.4pt;padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c45{margin-left:36.5pt;padding-top:1.1pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c59{margin-left:36.2pt;padding-top:6.3pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c24{padding-top:6.1pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c4{padding-top:5.9pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c21{padding-top:6.3pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c67{padding-top:5.8pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c73{padding-top:22.6pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c36{padding-top:6.2pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c18{padding-top:22.2pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c61{padding-top:22.5pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c27{padding-top:1.2pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c90{padding-top:38.5pt;padding-bottom:0pt;line-height:1.0;text-align:center}.c95{background-color:#ffffff;max-width:533.8pt;padding:25.9pt 25.8pt 66pt 35.4pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Arial"}p{margin:0;color:#000000;font-size:11pt;font-family:"Arial"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:14pt;color:#000000;font-weight:700;font-size:14pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}`}</style>

    <p className="c8">
      <span className="c0">Тұтынушылық келісім </span>
    </p>
    <p className="c28">
      <span className="c1">Бұл келісім </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        импульсты модулін сатып алғанда Өкіл мен Тұтынушының арасындағы хұқықтар мен міндеттерді
        анықтайтын шарт.{' '}
      </span>
    </p>
    <p className="c61">
      <span className="c1">1-тарау </span>
    </p>
    <p className="c67">
      <span className="c1">Тұтынушы хұқықтары: </span>
    </p>
    <p className="c87">
      <span className="c1">1.1. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулін сатып алғанда чек талап етуге хұқылы; </span>
    </p>
    <p className="c34">
      <span className="c1">1.2. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулін жұмысқа қабілетті күйінде алуға, яғни </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты &nbsp;Модулін тексеру барысына қатысуға хұқылы; </span>
    </p>
    <p className="c24">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c93">
      <span className="c1">
        тексеріс толық төлем мен ораманы ашқаннан соң және іске қосып Кепілді міндеттемелер
        басталғанға дейін өткізіледі,{' '}
      </span>
    </p>
    <p className="c65">
      <span className="c1">1.3. Өкілдің </span>
      <span className="c0">FPDtech</span>
      <span className="c1">-Сервис-Орталығында Тіркеу кестесінің барлық баптары бойынша </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Техническалық Регламентке &nbsp;сай сервистік қызмет қызмет алуға хұқылы{' '}
      </span>
    </p>
    <p className="c38">
      <span className="c1">1.4. </span>
      <span className="c0">FPDtech</span>
      <span className="c1">
        -Сервис-Орталығы мамандарынан Тіркеу кестесінің барлық баптарын толтыру барысында жеткілікті
        &nbsp;түсіндірмелер алуға хұқылы{' '}
      </span>
    </p>
    <p className="c19">
      <span className="c1">
        1.5. «Ерекше нарық» және «Агентік келісім» жоспарлары бойынша толық ақпарат алуға хұқылы{' '}
      </span>
    </p>
    <p className="c4">
      <span className="c1">1.6. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Өкілі өткізетін шаралар мен арнайы ұсыныстар, өзгерістер және жаңалықтар жайлы ақпарат алуға
        хұқылы{' '}
      </span>
    </p>
    <p className="c57">
      <span className="c1">1.7. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін қайтарым мерзімі бітпеген жағдайда (Қазақстан Республикасында 14 күн
        &nbsp;ішінде) қайтарып өткізуге хұқылы{' '}
      </span>
    </p>
    <p className="c24">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c3">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін қайтарып өткізген жағдайда Тұтынушыға оның Модулді сатып алуға жұмсаған
        нақты &nbsp;қаржысын қайтару Модулді толық тексеріп, оның{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі бүтіндігін бағалаудан және </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінің тауарлық түрінің сақталуы расталғанннан соң және Қайтарым құжатының
        толық толтырылуынан &nbsp;соң жүзеге асырылады.{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі қалыбының және жалғаушы кабелінің тазартылатын ластануы бұған &nbsp;кедергі
        болмайды.{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c64">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін бағасын шегеріп басқа тұтынушыға сату мүмкін болмауы себебі Өкілдің
        Тұтынушыға &nbsp;Модулді сатып алуға жұмсаған нақты қаржысын қайтармауға негіз болып
        саналады{' '}
      </span>
    </p>
    <p className="c42">
      <span className="c1">1.8. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі Кепілді міндеттемелер мезгілінде істен шығуы жағдайында{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінін тегін ауыстырып, оны тегін орнаттыруға хұқылы. Бұл жағдайда Модулдің
        сыртқы түрі &nbsp;есепке алынбайды{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c10">1-ескерту: </span>
    </p>
    <p className="c33">
      <span className="c1">
        Кепілді міндеттемелер мерзімі қосымша бонустық шартар болған жағдайда ұзартылуы мүмкін, бұл
        шартар Тұтынушы келіскен жағдайда &nbsp;ғана енгізіледі{' '}
      </span>
    </p>
    <p className="c21">
      <span className="c10">2-ескерту: </span>
    </p>
    <p className="c41">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі Кепілді міндеттемелер мезгілінде алмастырғаннан соң Кепілді міндеттемелер
        мерзімі &nbsp;жаңадан, яғни алмастыру күнінен қайта басталады. Кепілді міндеттемелер мерзімі
        жаңаруын тіркеу үшін{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» &nbsp;</span>
      <span className="c1">
        Импульсты Модулі жаңа реттік санын Тұтынушы Өндіруші интернет парақшасына{' '}
      </span>
      <span className="c16">www. fpdtech.kz </span>
      <span className="c1">сілтемесі арқылы жөнелтуі керек. </span>
    </p>
    <p className="c21">
      <span className="c10">3-ескерту: </span>
    </p>
    <p className="c54">
      <span className="c1">
        бонустық шартарға сай Тұтынушыға Өндірушінің интернет парақшасына хабарласу арқылы Кепілді
        міндеттемелер мерзімін қосымша &nbsp;төлеп жасап ұзарту мүмкіндігі бар.{' '}
      </span>
    </p>
    <p className="c94">
      <span className="c1">
        Кепілді міндеттемелер мерзімін мұндай өзгерту мерзімі бір жыл болып, оның төлемі{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі еш &nbsp;шегерімсіз бағасының 10 пайызын құрайды.{' '}
      </span>
    </p>
    <p className="c24">
      <span className="c10">4-ескерту: </span>
    </p>
    <p className="c50">
      <span className="c1">
        Кепілді міндеттемелер мерзімін Өндіруші Өкілдің қатысуынсыз Кепілді міндеттемелер тіркеу
        рәсімі өткізілмеген жағдайда кеміте алады.{' '}
      </span>
      <span className="c10">5-ескерту: </span>
    </p>
    <p className="c13">
      <span className="c1">Кепілді міндеттемелер </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі жұмыс қабілетіне ғана қатысы бар. </span>
    </p>
    <p className="c20">
      <span className="c1">
        Кепілді міндеттемелер тіркеу рәсімі өткен жағдайда ғана басталып, мерзімі 12 (он екі) айды
        құрайды.{' '}
      </span>
    </p>
    <p className="c84">
      <span className="c1">1.9. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Тіркеу кестесінің және осы Тұтынушылық келісімнің қағазға басылған және екі тараптың қол
        қоюы арқылы &nbsp;расталған түрін алуға құқылы{' '}
      </span>
    </p>
    <p className="c60">
      <span className="c1">
        1.10. «Ерекше нарық» жоспары шартарын орындап, Тіркеу кестесін толығымен жазып болған соң
        төлеген қаржысының &nbsp;18 (он сегіз) пайызын бірден алуға хұқылы.
      </span>
    </p>
    <p className="c8">
      <span className="c1">2-тарау. </span>
    </p>
    <p className="c4">
      <span className="c0">FPDtech </span>
      <span className="c1">ресми Өкілі </span>
    </p>
    <p className="c67">
      <span className="c1">(бұдан әрі - Өкіл) келесіге міндетті: </span>
    </p>
    <p className="c62">
      <span className="c1">2.1. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі төлемін растайтын чек беруге; </span>
    </p>
    <p className="c26">
      <span className="c1">2.2. төлем қабылдаған соң </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулінің жұмыс қабілеті мен бүтіндігін тексеруге; </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінің Жұмыс қабілеттілігі мен Бүтіндігінің өлшемшартарына сай модулды
        Тұтынышуға &nbsp;табыстауға{' '}
      </span>
    </p>
    <p className="c53">
      <span className="c1">2.3. </span>
      <span className="c0">FPDtech</span>
      <span className="c1">-Сервис-Орталығында </span>
      <span className="c0">FPDtech </span>
      <span className="c1">Тіркеу кестесінің барлық баптары мен </span>
      <span className="c0">FPDtech </span>
      <span className="c1">Техникалық Регламентіне сай &nbsp;сервистік қызметтерді атқаруға </span>
    </p>
    <p className="c92">
      <span className="c1">2.4. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Тіркеу кестесін толтыру барысында атқарылған барлық қызметтерге толықтай түсіндірме беруге;
        оның ішінде, &nbsp;қажет болған жағдайда, Тұтынушыға Өндірушімен оның интернет парақшасында
        тікелей байланыс орнатуға жәрдем беруге{' '}
      </span>
    </p>
    <p className="c59">
      <span className="c1">
        2.5. «Ерекше нарық» және «Агентік келісім» жоспарлары бойынша толық ақпарат беруге{' '}
      </span>
    </p>
    <p className="c71">
      <span className="c1">
        2.6. Тұтынушы өзімен хабар алмасуға жазбаша немесе электронды түрде келісім берген жағдайда
        жаңа қызметтер мен қызмет &nbsp;шартарының өзгеруі туралы хабар жөнелтіп тұруға{' '}
      </span>
    </p>
    <p className="c86">
      <span className="c1">2.7. Тұтынушының </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін заңмен белгіленген мерзімде қайтару хұқығын бұлжытпай &nbsp;қамтамасыз
        етуге{' '}
      </span>
    </p>
    <p className="c24">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c35">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін қайтарып өткізген жағдайда Тұтынушыға оның Модулді сатып алуға жұмсаған
        нақты &nbsp;қаржысын қайтару Модулді толық тексеріп, оның{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі бүтіндігін бағалаудан және </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінің тауарлық түрінің сақталуы расталғанннан соң және Қайтарым құжатының
        толық толтырылуынан &nbsp;соң жүзеге асырылады.{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі қалыбының және жалғаушы кабелінің тазартылатын ластануы бұған &nbsp;кедергі
        болмайды.{' '}
      </span>
    </p>
    <p className="c55">
      <span className="c1">2.9. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі Кепілді міндеттемелер мезгілінде істен шығуы жағдайында{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінін тегін ауыстырып, оны тегін орнатуға Бұл жағдайда Модулдің сыртқы түрі
        есепке &nbsp;алынбайды{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c10">1-ескерту: </span>
    </p>
    <p className="c33">
      <span className="c1">
        Кепілді міндеттемелер мерзімі қосымша бонустық шартар болған жағдайда ұзартылуы мүмкін, бұл
        шартар Тұтынушы келіскен жағдайда &nbsp;ғана енгізіледі{' '}
      </span>
    </p>
    <p className="c21">
      <span className="c10">2-ескерту: </span>
    </p>
    <p className="c41">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі Кепілді міндеттемелер мезгілінде алмастырғаннан соң Кепілді міндеттемелер
        мерзімі &nbsp;жаңадан, яғни алмастыру күнінен қайта басталады. Кепілді міндеттемелер мерзімі
        жаңаруын тіркеу үшін{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» &nbsp;</span>
      <span className="c1">
        Импульсты Модулі жаңа реттік санын Тұтынушы Өндіруші интернет парақшасына{' '}
      </span>
      <span className="c16">www. fpdtech.kz </span>
      <span className="c1">сілтемесі арқылы жөнелтуі керек. </span>
    </p>
    <p className="c21">
      <span className="c10">3-ескерту: </span>
    </p>
    <p className="c54">
      <span className="c1">
        бонустық шартарға сай Тұтынушыға Өндірушінің интернет парақшасына хабарласу арқылы Кепілді
        міндеттемелер мерзімін қосымша &nbsp;төлеп жасап ұзарту мүмкіндігі бар.{' '}
      </span>
    </p>
    <p className="c22">
      <span className="c1">
        Кепілді міндеттемелер мерзімін мұндай өзгерту мерзімі бір жыл болып, оның төлемі{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі еш &nbsp;шегерімсіз бағасының 10 пайызын құрайды.{' '}
      </span>
    </p>
    <p className="c24">
      <span className="c10">4-ескерту: </span>
    </p>
    <p className="c50">
      <span className="c1">
        Кепілді міндеттемелер мерзімін Өндіруші Өкілдің қатысуынсыз Кепілді міндеттемелер тіркеу
        рәсімі өткізілмеген жағдайда кеміте алады.{' '}
      </span>
      <span className="c10">5-ескерту: </span>
    </p>
    <p className="c80">
      <span className="c1">Кепілді міндеттемелер </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі жұмыс қабілетіне ғана қатысы бар. Кепілді міндеттемелер тіркеу &nbsp;рәсімі
        өткен жағдайда ғана басталып, мерзімі 12 (он екі) айды құрайды.{' '}
      </span>
    </p>
    <p className="c7">
      <span className="c1">
        2.10. Кепілді міндеттемелер мерзімі бойы Тұтынушы көлігін ауыстырған жағдайда,{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» &nbsp;</span>
      <span className="c1">Импульсты Модулін Тұтынушының басқа көлігіне </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі ресми толық құнының 10 &nbsp;(он) пайызынан аспайтын және «Ерекше нарық»
        жоспарын есепке алмайтын бағада орнатып беруге{' '}
      </span>
    </p>
    <p className="c72">
      <span className="c1">
        2.11.Кепілді міндеттемелер мерзімі аяқталып Тұтынушы көлігін ауыстырған жағдайда,{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты &nbsp;Модулін Тұтынушының басқа көлігіне </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі ресми толық құнының 20 (жиырма) &nbsp;пайызынан аспайтын және «Ерекше
        нарық» жоспарын есепке алмайтын бағада орнатып беруге{' '}
      </span>
    </p>
    <p className="c96">
      <span className="c1">2.12. Тұтынушының Аты-жөнін, телефон номерін, </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі орнатылған көлігінің &nbsp;тіркеу номерін ешбір үшінші тарапқа ауызша
        немесе жазбаша жеткізбеуге, ешбір жерде жарияламауға{' '}
      </span>
    </p>
    <p className="c88">
      <span className="c1">2.13. Толығымен толтырылған </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Тіркеу кестесінің және осы Келісімнің қағазға басылған және екі тараппен &nbsp;рәсімделген
        данасын міндетті түрде табыстау
      </span>
    </p>
    <p className="c39">
      <span className="c1">
        2.14. «Ерекше нарық» жоспары шартарын орындап, Тіркеу кестесін толығымен жазып болған соң
        төлеген қаржысының &nbsp;18 (он сегіз) пайызын бірден беруге{' '}
      </span>
    </p>
    <p className="c73">
      <span className="c1">3-тарау. </span>
    </p>
    <p className="c4">
      <span className="c1">Тұтынушы келесіге міндетті: </span>
    </p>
    <p className="c83">
      <span className="c1">3.1. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін ол арналған кернеу мен көлік санатында ғана пайдалану;{' '}
      </span>
      <span className="c10">ескерту: </span>
    </p>
    <p className="c69">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі арналған кернеу мен көлік санаттары Өндірушінің </span>
      <span className="c16">www . fpdtech .</span>
      <span className="c43">kz </span>
      <span className="c1">интернет парақшасында &nbsp;жарияланады </span>
    </p>
    <p className="c56">
      <span className="c1">санаттан тыс пайдалануға келесідей жағдайлар жатады: </span>
    </p>
    <p className="c20">
      <span className="c0">FPDtech</span>
      <span className="c1">-Сервис-Орталығы маманы орнатпай, қоспай, өз бетімен қосу-орнату; </span>
    </p>
    <p className="c77">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін ол арналмаған кернеу мен көлік санаттарына қосу-орнату 3.2{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін басқа тұлғаларға ол арналмаған нысанда қолдану үшін табыстамау; 3.3{' '}
      </span>
      <span className="c0">FPDtech </span>
      <span className="c1">Тіркеу кестесін толтыру кезінде тек шынайы мәлімет беру </span>
    </p>
    <p className="c27">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c66">
      <span className="c1">
        Тұтынушы Аты-жөнін, байланыс телефонын, көлігін ауыстырған жағдайда Кепілді міндеттемер
        мерзімі аяқталмай тұрып уақытылы &nbsp;мұндай өзгерістерді Өндірушіге интернет парақшасы
        арқылы хабарлап отыруы шарт.{' '}
      </span>
    </p>
    <p className="c21">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c30">
      <span className="c1">
        Тұтынушы кездейсоқ немесе қасақана жалған ақпарат берген жағдайда Өндіруші мен Өкіл оларға
        қатысты Кепілді міндеттемелер &nbsp;орындау міндетінен босатылады.{' '}
      </span>
    </p>
    <p className="c46">
      <span className="c1">3.4. Өндірушіге </span>
      <span className="c0">FPDtech </span>
      <span className="c1">Тіркеу кестесін </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Техникалық Регламентіне сай толтыру барысында алынған мәліметтерді &nbsp;жариялау хұқығын
        береді. Бұл мәліметтерге Тұтынушының Аты-жөні, телефон номері,{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» &nbsp;</span>
      <span className="c1">Импульсты Модулі орнатылған көлігінің тіркеу номері кірмейді. </span>
    </p>
    <p className="c78">
      <span className="c1">3.5. </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулі орнатылған көлігі ауысқан жағдайда </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты &nbsp;Модулін басқа көлігіне </span>
      <span className="c0">FPDtech</span>
      <span className="c1">
        -Сервис-Орталығында орнаттырып Кепілді міндеттемелерін қайта тіркетуге;{' '}
      </span>
    </p>
    <p className="c21">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c17">
      <span className="c1">Модулді басқа көлікке орнаттыру Өкілдің </span>
      <span className="c0">FPDtech</span>
      <span className="c1">
        -Сервис-Орталығында арнайы осы Келісімнің 2.10. және 2.11. баптарында &nbsp;қарастырылған
        жағдайларда жасалады;{' '}
      </span>
    </p>
    <p className="c81">
      <span className="c1">3.6. Тұтынушылық келісімнің барлық баптарын оқу; </span>
    </p>
    <p className="c5">
      <span className="c1">
        3.7. осы келісімнің барлық тараулары және бапатарымен танысып, оны Аты-жөнін жазып қол қою
        арқылы растау{' '}
      </span>
    </p>
    <p className="c47">
      <span className="c1">
        3.8. өз Аты-жөнін жазып, қолын қойып, растау мүмкін болмаған жағдайда{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін төлеу &nbsp;дерегін осы келісімнің 3.6. және 3.7 баптарының орындалуы және
        Тұтынушылық келісім шартарымен толықтай келісуі деп &nbsp;мойындау;{' '}
      </span>
    </p>
    <p className="c75">
      <span className="c1">
        3.9. өз көлігі техникалық жағдайы және құрамдас бөліктері мен бөлшектерінің көлік өндірушісі
        талаптарына толықтай сай &nbsp;болуына, көлгіне арналмаған бөтен құрылғылардың{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі орнатылуына дейін &nbsp;орнатылмауына жеке толық қаржылық жауапкершілігін
        мойнына алу;{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c1">4-тарау. </span>
    </p>
    <p className="c4">
      <span className="c1">Өкіл келесіге хұқылы: </span>
    </p>
    <p className="c37">
      <span className="c1">4.1. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">Өндірушісімен арадағы Әріптестік шартқа сай, Тұтынушының көлігі </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        техникалық регламенті шартарына &nbsp;орай жұмысқа қабілетті болмаған жағдайда Тұтынушыға{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулін сатпауға </span>
    </p>
    <p className="c58">
      <span className="c1">4.2. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">тіркеу кестесін толтыруға қажетті құралдарға қатысты </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        техникалық регламенті талаптарына сай жөндеу тексеру жұмыстары өткізіліп жатқан кезде
        атқарылуы тиісті қызметтерді басқа мерзімге жылжытуға{' '}
      </span>
    </p>
    <p className="c52">
      <span className="c1">4.3. қайтарым мерзімі кезеңінде, жұмысқа қабілетті </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулін қайтарғанда, оның «</span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулінің жұмысқа қабілеттілігі» талаптарына және «</span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты &nbsp;Модулінің тауарлы келбеттілігі» талаптарына толықтай сайласпауы жағдайында
        ол модулдің келешекте басқа тұтынушыға &nbsp;арзандатып сатылуы мүмкіндігі тұрғысынан
        қаржының қайтарым мөлшерін өз бетімен тағайындауға{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c2">
      <span className="c1">
        модулдің келешекте басқа тұтынушыға арзандатып сатылуы мүмкін болмауы айқындалған жағдайда
        Тұтынушыға{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін сатып алуға жұмсалған нақты қаржының қайтарылмауына сөзсіз негіз болады.{' '}
      </span>
    </p>
    <p className="c31">
      <span className="c1">
        4.4. болашақ тұтынушылардың назарын аудару мақсатында өздігінен арнайы жоспарлар мен
        әрекеттер ұйымдастыруына &nbsp;болады. Ол жоспарлар мен әрекеттер осы Келісім мен Әріптестік
        шартқа толықтай сәкесуі керек.{' '}
      </span>
    </p>
    <p className="c59">
      <span className="c1">4.5. </span>
      <span className="c0">FPDtech </span>
      <span className="c1">
        Өндірушісімен жасалған Әріптестік шартқа қатысы жоқ заттарды сатып, қызмет атқаруға
      </span>
    </p>
    <p className="c8">
      <span className="c1">5-тарау. </span>
    </p>
    <p className="c67">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулінің жұмысқа қабілеттілігін </span>
    </p>
    <p className="c4">
      <span className="c1">тексеру </span>
    </p>
    <p className="c18">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулінің жұмысқа қабілеттілігін </span>
    </p>
    <p className="c40">
      <span className="c1">тексеру келесідей ретте атқарылады: </span>
    </p>
    <p className="c79">
      <span className="c1">
        5.1. көлікті тұтатқышын қосу (оталдыру кілттін ON қалпына бұрау, немесе оталдыру батырмасын,
        тежеуіш тепкісін баспай &nbsp;тұрып, екі рет басу) – Модулдің индикаторы жануы керек{' '}
      </span>
    </p>
    <p className="c48">
      <span className="c1">5.2. көлікті тұтатқышын сөндіру – Модулдің индикаторы сөну керек; </span>
    </p>
    <p className="c9">
      <span className="c1">5.3. сақтандырғышты қалыбынан шығару </span>
    </p>
    <p className="c14">
      <span className="c1">5.4. Мультиметрді тұрақты тоқ өлшеу қалпына қосу </span>
    </p>
    <p className="c9">
      <span className="c1">
        5.5. Мультиметр сымдарын сақтандырғыш қалыбындағы контактерге қосу &nbsp;
      </span>
    </p>
    <p className="c14">
      <span className="c1">5.6. тұтатқышты қосу – Модулдің индикаторы жануы керек </span>
    </p>
    <p className="c9">
      <span className="c1">
        5.7. Мультиметр көрсеткіші «10-100мА» немесе «-10-100мА» көрсетсе Модуль аман деген сөз{' '}
      </span>
    </p>
    <p className="c14">
      <span className="c1">5.8. тұтатқышты ажыратыңыз </span>
    </p>
    <p className="c9">
      <span className="c1">5.9. сақтандырғышты орнына салыңыз, тексеріс аяқталды </span>
    </p>
    <p className="c82">
      <span className="c1">Тұтатқышты қосқанда Индикатор жанбаған жағдайда </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін тексеру келесі тәртіпте атқарылады: 5.10. тұтатқышты сөндіріңіз{' '}
      </span>
    </p>
    <p className="c45">
      <span className="c1">
        5.11.Модулді кабелінен ажыратыңыз, кабелді көліктен ажыратып шығарыңыз{' '}
      </span>
    </p>
    <p className="c11">
      <span className="c1">
        5.12. сақтандырғышты қалыбынан шығарып тексеріңіз, егер сақтандырғыш сау болса келесі бапқа
        өтіңіз 5.13. Мультиметрді диод тексеру қалпына ауыстырыңыз{' '}
      </span>
    </p>
    <p className="c23">
      <span className="c1">5.14. Модулге кабелін қосыңыз </span>
    </p>
    <p className="c68">
      <span className="c1">
        5.15. кабелдің қызыл сымын, яғни «+»ын Мультиметрдің «-»на, кабелдің қара сымын, яғни «-»ын
        Мультиметрдің &nbsp;«+»мен қосыңыз;{' '}
      </span>
    </p>
    <p className="c70">
      <span className="c1">
        5.16. Мультиметр көрсеткіші «0,5-0,8V» болса Модуль сау, бірақ Өндіруші тарапынан ақауы бар,
        Кепілді &nbsp;міндеттемелерге сай алмастырылуы керек{' '}
      </span>
    </p>
    <p className="c63">
      <span className="c1">
        Кейбір жағдайда тұтатқыш қосылғанда Индикатор жанбай Сақтандырғыш күйген болса келесіде
        жасаңыз: сақтандырғышты ауыстырыңыз, егер Тұтатқышты қосқанда Индикатор жанса – тесеріс
        аяқталғаны. &nbsp;
      </span>
    </p>
    <p className="c15">
      <span className="c1">
        Сақтандырғыш ауыстырылып, тұтатқышты қосқанда Индикатор жанбаса, келесідей жасаңыз:{' '}
      </span>
    </p>
    <p className="c14">
      <span className="c1">5.17. Мультиметрді диод тексеру қалыбына ауыстырыңыз; </span>
    </p>
    <p className="c9">
      <span className="c1">
        5.18. Модулді кабелінен ажыратыңыз, кабелді көліктен ажыратып шығарыңыз{' '}
      </span>
    </p>
    <p className="c14">
      <span className="c1">5.19. Модулге кабелін қосыңыз </span>
    </p>
    <p className="c68">
      <span className="c1">
        5.20. кабелдің қызыл сымын, яғни «+»ын Мультиметрдің «-»на, кабелдің қара сымын, яғни «-»ын
        Мультиметрдің &nbsp;«+»мен қосыңыз{' '}
      </span>
    </p>
    <p className="c70">
      <span className="c1">
        5.21. Мультиметр көрсеткіші «0,5-0,8V» болса Модуль сау, бірақ Өндіруші тарапынан ақауы бар,
        Кепілді &nbsp;міндеттемелерге сай алмастырылуы керек{' '}
      </span>
    </p>
    <p className="c44">
      <span className="c1">
        5.22. Мультиметр көрсеткіші «0» немесе «1», немесе шексіз кернеу түсуін көрсетсе, бұл Модуль
        кабелі теріс &nbsp;жалғануынан немесе өзі арналмаған санаттағы көлікке жалғануы себепті
        біржола істен шыққандығын білдіреді{' '}
      </span>
    </p>
    <p className="c61">
      <span className="c1">Өндірушінің мәлімдемесі: </span>
    </p>
    <p className="c29">
      <span className="c1">
        Модуль кабелі теріс жалғануынан немесе өзі арналмаған санаттағы көлікке жалғануы себепті
        біржола істен шыққанды Өндіруші &nbsp;тарапынан болған кемшілікке жатпайды. Бұл осы Келісім
        3.1 бабының қасақана немесе кездейсоқ бұзылуы делініп, Тұтынушының &nbsp;
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін сатып алуға жұмсаған нақты қаржысының қайтарылмауына себеп теп танылады.{' '}
      </span>
    </p>
    <p className="c73">
      <span className="c1">6-тарау. </span>
    </p>
    <p className="c4">
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">Импульсты Модулінің тауарлы келбеттілігі белгілері: </span>
    </p>
    <p className="c89">
      <span className="c1">
        6.1. Модуль қалыбының бұзылуы, нақты айтқанда – жырылуы, сырылуы, майысуы, жарылуы, термо
        және термо-электрлі &nbsp;әсерлерден болған іздер, тазармайтын немесе толық тазармайтын
        техникалық сұйықтардан қалған іздер мен дақтар, Модуль &nbsp;қақпағындағы кабель
        жалғауышының зақымдалуы
      </span>
    </p>
    <p className="c91">
      <span className="c1">
        6.2. кабель зақымдарына кабель изоляциялы қабатының бұзылуы, үзілуі, жарылуы, термо және
        термо-электрлі әсерлерден &nbsp;болған іздер, тазармайтын немесе толық тазармайтын
        техникалық сұйықтардан қалған іздер мен дақтар, сақтандырғыштың &nbsp;зақымдалуы{' '}
      </span>
    </p>
    <p className="c49">
      <span className="c1">6.3. зақымдалған кабель қалпына келтірілмейді </span>
    </p>
    <p className="c74">
      <span className="c1">зақымдалған кабелдің ақысын Өкіл тағайындап, ол ақы </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулінің «Ерекше нарық» жоспары &nbsp;есебінсіз ресми құнының 10 (он) пайызынан
        аспайды.{' '}
      </span>
    </p>
    <p className="c73">
      <span className="c1">7-тарау. </span>
    </p>
    <p className="c4">
      <span className="c1">Тұтынушы мен Өкіл арасындағы дауларды шешу </span>
    </p>
    <p className="c76">
      <span className="c1">
        7.1 Тұтынушы мен Өкіл арасында туған дауларды Сотқа жүгінбей өзара ымыраластықпен шешуге
        тырысады{' '}
      </span>
    </p>
    <p className="c51">
      <span className="c1">7.2 Тұтынушының көлігі ақаулары </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін қосудан соң табылған жағдайда, сонымен &nbsp;қатар Тұтынушының ойынша{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулі пайдалылығы Тұтынушы көлігінде білінбеген &nbsp;жағдайда, Өкіл ондай
        арыздарды Арыз қабылдау протоколына сай қабылдайды{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c25">
      <span className="c1">
        Арыз қабылдау протоколы келесі құжаттарды құрайды: Тұтынушылық келісімнің түпнұсқасы, төлем
        чегінің түпнұсқасы, Тіркеу &nbsp;кестесінің түпнұсқасы, сертификатталған мекеменің Тұтынушы
        көлігі барлық құрамдас бөліктерінің жағдайы мен{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін қосу күніне дейін Тұтынушы көлігінің Көлікті өндіруші Техникалық
        талаптарына сай болғандығын &nbsp;растайтын құжат{' '}
      </span>
    </p>
    <p className="c21">
      <span className="c10">ескерту: </span>
    </p>
    <p className="c6">
      <span className="c1">
        сертификатталған мекеменің Тұтынушы көлігі барлық құрамдас бөліктерінің жағдайы мен{' '}
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін &nbsp;қосу күніне дейін Тұтынушы көлігінің Көлікті өндіруші Техникалық
        талаптарына сай болғандығын растайтын құжат Тұтынушы көлігіне &nbsp;
      </span>
      <span className="c0">FPDtech «Super Torque» </span>
      <span className="c1">
        Импульсты Модулін орнатқанға дейінгі және оны орнатқаннан кейінгі жағдайын тәуелсіз мамандар
        қатысуымен &nbsp;салыстырмалы түрде сараптауға жалғыз негіздеме бола алады.{' '}
      </span>
    </p>
    <p className="c36">
      <span className="c1">8-тарау. </span>
    </p>
    <p className="c4">
      <span className="c1">Келісімнің жарамдылық мерзімі </span>
    </p>
    <p className="c85">
      <span className="c1">8.1. Бұл Келісім 12 (он екі) ай бойы жарамды. </span>
    </p>
    <p className="c12">
      <span className="c1">8.2. 1-тараудағы 3-ескертуге сай, Тұтынушының Өндірушімен </span>
      <span className="c16">www.fpdtech.kz </span>
      <span className="c1">
        интернет парақшасы арқылы тікелей байланысуы &nbsp;нәтижесінде Кепілді мерзімнің өзгертілуі
        Келісімнің жарамдылық мерзіміне қатысы жоқ.{' '}
      </span>
    </p>
    <p className="c32">
      <span className="c1">
        8.3. Бұл Келісім екі тараптың қолдарымен рәсімделуінен бастап күшіне енеді.{' '}
      </span>
    </p>
    <p className="c90">
      <span className="c1">
        Тұтынушылық келім ________________________ күні заңды күші бірдей екі данада рәсімделді{' '}
      </span>
    </p>
    <p className="c18">
      <span className="c1">
        Тұтынушының аты-жөні__________________________________________қолы___________{' '}
      </span>
    </p>
    <p className="c18">
      <span className="c1">Өкіл, аты-жөні_______________________________қолы___________мөрі</span>
    </p>
  </>
);
